import styled from 'styled-components/macro';
import { rgba } from 'polished';
import { bool, number, node, string } from 'prop-types';

import CompareBullet from 'components/styled/CompareBullet/CompareBullet';
import LoadingBar from 'components/styled/LoadingBar/LoadingBar';
import { ArtworkWrapper } from 'components/base/EntityItem/EntityItem.style';

import modularScale from 'styles/helpers/modular-scale';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-top: 0.5em;
  padding: ${({ theme }) => theme.spacing.xsmall};
  background: ${({ theme }) => rgba(theme.NightBlue, 0.15)};
  position: relative;

  ${ArtworkWrapper} {
    margin-right: ${({ theme }) => theme.spacing.xsmall};
  }

  @media screen and (min-width: 30em) {
    padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.large}`};
    margin-top: 1em;

    ${ArtworkWrapper} {
      margin-right: ${({ theme }) => theme.spacing.medium};
    }
  }
`;

const Content = styled('div')`
  margin: ${({ theme, error }) =>
    error ? `0 ${theme.spacing.xxsmall} 0 0` : `0 ${theme.spacing.xxsmall}`};
  min-height: ${({ error }) => (error ? modularScale(6) : 'initial')};
  flex-grow: 1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: 30em) {
    margin: ${({ theme, error }) =>
      error ? `0 ${theme.spacing.xsmall} 0 0` : `0 ${theme.spacing.xsmall}`};
  }
`;

const LoadingBarWrapper = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

/** Styled Entity CompareItem wrapper. */
const CompareListItem = ({ index, loading, children, error, className }) => {
  return (
    <Wrapper className={className} data-pw="compare-list-item">
      <LoadingBarWrapper>
        <LoadingBar
          loading={loading}
          delay={0}
          gradientColor="rgba(255,255,255,0.15)"
        />
      </LoadingBarWrapper>
      {!error && <CompareBullet index={index} />}
      <Content error={error}>{children}</Content>
    </Wrapper>
  );
};

export default CompareListItem;

CompareListItem.propTypes = {
  /** Required when composing styled components */
  className: string,
  /** Is the EntityMetadata currently loading? */
  loading: bool,
  /** The sequence number in the list used to define the compare color */
  index: number,
  /** The Components children */
  children: node.isRequired,
  /** Is this Entity currently in error state? */
  error: bool,
};
